// extracted by mini-css-extract-plugin
module.exports = {"floatingCTA":"FloatingCTA-module--floatingCTA--1gu1W","text":"FloatingCTA-module--text--lX32X","button":"FloatingCTA-module--button--3XTVS"};